import { VyneInputNumberWithAddon } from "components/vyneInputs/inputAddonWrapper/VyneInputNumberWithAddon";
import { currencyInputNumberProps } from "./currencyInput";
import type { InputNumberProps } from "antd";
import type { ReactNode } from "react";
import type { SpaceCompactProps } from "antd/es/space/Compact";

type CurrencyInputNumberProps = Omit<InputNumberProps<number>, "addonBefore" | "addonAfter"> & {
    readonly addonBefore?: ReactNode;
    readonly addonAfter?: ReactNode;
    readonly wrapperProps?: Omit<SpaceCompactProps, "children">;
};

export const CurrencyInputNumber = ({
    addonBefore = "$",
    addonAfter,
    wrapperProps,
    ...props
}: CurrencyInputNumberProps) => (
    <VyneInputNumberWithAddon
        addonBefore={addonBefore}
        addonAfter={addonAfter}
        wrapperProps={wrapperProps}
        {...currencyInputNumberProps}
        {...props}
    />
);
